module.exports = __webpack_public_path__ + "media/images/flags/64/Australia-09eb1b6cafbaf91adc55b2fe2dea4af9.png";